import React from 'react';

const HowEthosfloWasBorn = () => {
  return (
    <section
      id="howethosflo"
      className="bg-[#062B37] text-green px-6 py-8 md:px-10 max-h-[80vh] overflow-y-auto pb-12 rounded-lg"
    >
      <div className="max-w-5xl mx-auto">
        {/* <h2 className="text-xl font-bold text-center mb-10 text-green-400">
          How Ethosflo Was Born
        </h2> */}

        <div className="space-y-4 text-base">
          <div>
            <h3 className="text-base font-semibold mb-2 text-green-400">Situation</h3>
            <p className="text-justify">
              With rising regulations and investor and customer demands around the ESG aspects globally, organizations are
              now required to demonstrate sustainable development practices not only in their direct operations (owned
              offices, vehicles, manufacturing facilities, buildings, land, etc.) but also in their indirect operations
              (supplier’s operation, farm from where milk is sourced, construction material suppliers, purchaser of
              packaging, portfolio companies, etc.).
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-2 text-green-400">Task</h3>
            <p className="text-justify">
              Organizations need to assess the maturity of business partners in their value chain on ESG aspects to comply
              with regulations and at the same time ensure that the functional core teams (like purchase or sales) are not
              stretched in their resource bandwidth so as not to affect their core responsibilities. By proactively
              assessing risk in their value chain, organizations are expected to go beyond regulatory compliance and towards
              strategic business advantage.
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-2 text-green-400">Challenge</h3>
            <p className="text-justify">
              In our experience, most procurement teams are struggling with the rising burden of ESG-assessment of their
              business partners. Undertaking the assessment in-house requires capacity building of the procurement team on
              ESG aspects, training and educating the business partners, systems and infrastructure upgrades, and continuous
              monitoring – too much to ask in too short time!
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-2 text-green-400">Solution</h3>
            <p className="text-justify">
              Ethosflo was born out of this crisis to help organizations outsource this periodic maturity assessment of their
              business partners by ESG experts who bring the required knowledge. Most importantly, Ethosflo is affordable,
              customizable, and easy-to-operate so that organizations, including small and medium enterprises (SMEs),
              require the minimal effort. A dedicated account manager is assigned to individual assessee to handhold them in
              the entire assessment journey.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowEthosfloWasBorn;